export default "__VITE_ASSET__wAw6wGRk__"